import React from "react";
import ReactDOM from "react-dom/client";
import store from "./store";
import "./App.scss";
import { Provider } from "react-redux";
import Router from "./router";
import { RouterProvider } from "react-router-dom";
import Loading from "./routes/Loading";
import * as Sentry from "@sentry/react";

// Initialize Sentry
Sentry.init({
  dsn: "https://83f23afb2b7081a1758a5fcebea1f94b@o1132036.ingest.us.sentry.io/4507528896380928",
  environment: "production",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,
});

export const Logger = () => ({
  log: (message: string, extra?: any) => {
    console.log(message, extra);
    Sentry.addBreadcrumb({
      message,
      level: 'info',
      data: extra,
    });
  },
  error: (message: string, error?: Error | any) => {
    console.error(message, error);
    if (error instanceof Error) {
      Sentry.captureException(error);
    } else {
      Sentry.captureMessage(message, 'error');
    }
  },
  warn: (message: string, extra?: any) => {
    console.warn(message, extra);
    Sentry.addBreadcrumb({
      message,
      level: 'warning',
      data: extra,
    });
  },
});

ReactDOM.createRoot(
  document.getElementById("surestore-rapidstor-frontend") as HTMLElement
).render(
  // <React.StrictMode>
  <Provider store={store}>
    <RouterProvider router={Router} fallbackElement={<Loading />} />
  </Provider>
  // </React.StrictMode>
);
